<template>
  <highcharts class="hc"
              :options="options"
              ref="charts"/>
</template>

<script>
export default {
  props: ['standmans'],
  data (vm) {
    return {
      options: {
        chart: {
          type: 'line',
          zoomType: 'x',
          height: '350px',
          backgroundColor: '#F3F2F7',
          borderRadius: 10,
          marginRight: '30',
          marginTop: '50',
          marginBottom: '50'
        },
        subtitle: {
          text: this.$t('statistic.collectedDataChart.subtitle')
        },
        title: {
          text: ''
        },

        credits: {
          enabled: false
        },

        legend: {
          enabled: false
        },

        // subtitle: {
        //   text: document.ontouchstart === undefined ?
        //     'Щелкните и перетащите область графика, чтобы увеличить' : 'Зажмите диаграмму, чтобы увеличить'
        // },
        xAxis: {
          type: 'datetime'
        },
        yAxis: {
          title: {
            text: this.$t('statistic.collectedDataChart.totalScansShort')
          }
        },

        plotOptions: {
          area: {
            stacking: 'normal',
            lineColor: '#666666',
            lineWidth: 1,
            marker: {
              lineWidth: 1,
              lineColor: '#666666'
            }
          }
        },
        series: [
          {
            name: '',
            data: []
          }
        ]
      }
    };
  },
  methods: {
    // updateSeries(newVal) {
    //   const elem = this.$refs.charts;
    //   if (newVal != undefined) {
    //     elem.chart.update({
    //       series: newVal,
    //     });
    //     return;
    //   }
    //   elem.chart.update({
    //     series: this.standmans,
    //   });
    // },
  },
  mounted() {
    // console.log(this.standmans);
  },
  watch: {
    standmans(newVal, oldVal) {
      if (JSON.stringify(newVal) == JSON.stringify(oldVal)) return;
      const elem = this.$refs.charts;
      elem.chart.update(
        {
          series: newVal
        },
        true,
        true,
        true
      );
    }
  }
};

// [
//   {
//     name: 'Asia',
//     data: [[1621335600, 2], [1621598400, 4], [1622548800, 1]]
//   },{
//     name: 'Africa',
//     data: [[1621335600, 4], [1621598400, 41], [1622548800, 10]]
//   },{
//     name: 'Europe',
//     data: [[1621335600, 1], [1621598400, 14], [1622548800, 21]]
//   },{
//     name: 'America',
//     data: [[1621335600, 20], [1621598400, 6], [1622548800, 45]]
//   },{
//     name: 'Oceania',
//     data: [[1621335600, 22], [1621598400, 7], [1622548800, 12]]
//   }
// ]

// import Highcharts from 'highcharts';
// import { uuid } from 'vue-uuid';

// export default {
//   props: ['standmans'],

//   data: () => ({
//     id: uuid.v1().replace(/\-/g, ''),

//     standmansArr: []
//   }),

//   mounted() {
//     this.standmansArr = this.standmans.map(item => {
//       return ({
//         name: `${ item.name.first} ${ item.name.last}`,
//         data: item.forHours.map(el => [el.time * 1000, el.total])
//       })
//     })

//     this.printChart()
//   },

//   watch: {
//     standmans: function() {
//       this.standmansArr = this.standmans.map(item => {
//         return ({
//           name: `${ item.name.first} ${ item.name.last}`,
//           data: item.forHours.map(el => [el.time * 1000, el.total])
//         })
//       })

//       this.printChart()
//     }
//   },

//   methods: {
//     printChart() {
//       let chartBlock = this.$refs[this.id]

//       Highcharts.setOptions({
//         lang: {
//           resetZoom: 'Сбросить масштаб',
//         }
//       })

//       Highcharts.chart(chartBlock, {
//         chart: {

//         },

//         title: {
//           text: ''
//         },

//         // subtitle: {
//         //   text: document.ontouchstart === undefined ?
//         //     'Щелкните и перетащите область графика, чтобы увеличить' : 'Зажмите диаграмму, чтобы увеличить'
//         // },
//         xAxis: {
//           type: 'datetime'
//         },
//         yAxis: {
//           title: {
//             text: 'Количество сканов'
//           }
//         },

//         plotOptions: {
//           area: {
//               stacking: 'normal',
//               lineColor: '#666666',
//               lineWidth: 1,
//               marker: {
//                   lineWidth: 1,
//                   lineColor: '#666666'
//               }
//           }
//         },

//         series: this.standmansArr
//           // [{
//           //     name: 'Asia',
//           //     data: [[1621335600, 2], [1621598400, 4], [1622548800, 1]]
//           // }, {
//           //     name: 'Africa',
//           //     data: [[1621335600, 4], [1621598400, 41], [1622548800, 10]]
//           // }, {
//           //     name: 'Europe',
//           //     data: [[1621335600, 1], [1621598400, 14], [1622548800, 21]]
//           // }, {
//           //     name: 'America',
//           //     data: [[1621335600, 20], [1621598400, 6], [1622548800, 45]]
//           // }, {
//           //     name: 'Oceania',
//           //     data: [[1621335600, 22], [1621598400, 7], [1622548800, 12]]
//           // }]

//       });
//     }
//   },
// }
</script>
